/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Pizza Checker API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PostCountAnnotationsBody,
  PostListAnnotationsBody,
  PostUpsertAnnotationBody,
  PutUpdateAnnotationBody,
} from ".././schemas";

import { customInstance } from "../../axios-instance";
import type { ErrorType, BodyType } from "../../axios-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const postUpsertAnnotation = (
  postUpsertAnnotationBody: BodyType<PostUpsertAnnotationBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/pizza_annotations/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postUpsertAnnotationBody,
      signal,
    },
    options,
  );
};

export const getPostUpsertAnnotationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpsertAnnotation>>,
    TError,
    { data: BodyType<PostUpsertAnnotationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUpsertAnnotation>>,
  TError,
  { data: BodyType<PostUpsertAnnotationBody> },
  TContext
> => {
  const mutationKey = ["postUpsertAnnotation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUpsertAnnotation>>,
    { data: BodyType<PostUpsertAnnotationBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postUpsertAnnotation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUpsertAnnotationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUpsertAnnotation>>
>;
export type PostUpsertAnnotationMutationBody =
  BodyType<PostUpsertAnnotationBody>;
export type PostUpsertAnnotationMutationError = ErrorType<unknown>;

export const usePostUpsertAnnotation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUpsertAnnotation>>,
      TError,
      { data: BodyType<PostUpsertAnnotationBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUpsertAnnotation>>,
  TError,
  { data: BodyType<PostUpsertAnnotationBody> },
  TContext
> => {
  const mutationOptions = getPostUpsertAnnotationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postCountAnnotations = (
  postCountAnnotationsBody: BodyType<PostCountAnnotationsBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/pizza_annotations/count`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postCountAnnotationsBody,
      signal,
    },
    options,
  );
};

export const getPostCountAnnotationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCountAnnotations>>,
    TError,
    { data: BodyType<PostCountAnnotationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCountAnnotations>>,
  TError,
  { data: BodyType<PostCountAnnotationsBody> },
  TContext
> => {
  const mutationKey = ["postCountAnnotations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCountAnnotations>>,
    { data: BodyType<PostCountAnnotationsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postCountAnnotations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCountAnnotationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCountAnnotations>>
>;
export type PostCountAnnotationsMutationBody =
  BodyType<PostCountAnnotationsBody>;
export type PostCountAnnotationsMutationError = ErrorType<unknown>;

export const usePostCountAnnotations = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCountAnnotations>>,
      TError,
      { data: BodyType<PostCountAnnotationsBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCountAnnotations>>,
  TError,
  { data: BodyType<PostCountAnnotationsBody> },
  TContext
> => {
  const mutationOptions = getPostCountAnnotationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postListAnnotations = (
  postListAnnotationsBody: BodyType<PostListAnnotationsBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/pizza_annotations/list`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postListAnnotationsBody,
      signal,
    },
    options,
  );
};

export const getPostListAnnotationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postListAnnotations>>,
    TError,
    { data: BodyType<PostListAnnotationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postListAnnotations>>,
  TError,
  { data: BodyType<PostListAnnotationsBody> },
  TContext
> => {
  const mutationKey = ["postListAnnotations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postListAnnotations>>,
    { data: BodyType<PostListAnnotationsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postListAnnotations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostListAnnotationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postListAnnotations>>
>;
export type PostListAnnotationsMutationBody = BodyType<PostListAnnotationsBody>;
export type PostListAnnotationsMutationError = ErrorType<unknown>;

export const usePostListAnnotations = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postListAnnotations>>,
      TError,
      { data: BodyType<PostListAnnotationsBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postListAnnotations>>,
  TError,
  { data: BodyType<PostListAnnotationsBody> },
  TContext
> => {
  const mutationOptions = getPostListAnnotationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getAnnotationByPizzaId = (
  pizzaId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/admin/pizza_annotations/${pizzaId}`, method: "GET", signal },
    options,
  );
};

export const getGetAnnotationByPizzaIdQueryKey = (pizzaId: string) => {
  return [`/api/admin/pizza_annotations/${pizzaId}`] as const;
};

export const getGetAnnotationByPizzaIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
  TError = ErrorType<unknown>,
>(
  pizzaId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnnotationByPizzaIdQueryKey(pizzaId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnnotationByPizzaId>>
  > = ({ signal }) => getAnnotationByPizzaId(pizzaId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pizzaId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAnnotationByPizzaIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnnotationByPizzaId>>
>;
export type GetAnnotationByPizzaIdQueryError = ErrorType<unknown>;

export function useGetAnnotationByPizzaId<
  TData = Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
  TError = ErrorType<unknown>,
>(
  pizzaId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
          TError,
          Awaited<ReturnType<typeof getAnnotationByPizzaId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAnnotationByPizzaId<
  TData = Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
  TError = ErrorType<unknown>,
>(
  pizzaId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
          TError,
          Awaited<ReturnType<typeof getAnnotationByPizzaId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAnnotationByPizzaId<
  TData = Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
  TError = ErrorType<unknown>,
>(
  pizzaId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAnnotationByPizzaId<
  TData = Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
  TError = ErrorType<unknown>,
>(
  pizzaId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnnotationByPizzaId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAnnotationByPizzaIdQueryOptions(pizzaId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putUpdateAnnotation = (
  pizzaId: string,
  putUpdateAnnotationBody: BodyType<PutUpdateAnnotationBody>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/pizza_annotations/${pizzaId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: putUpdateAnnotationBody,
    },
    options,
  );
};

export const getPutUpdateAnnotationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putUpdateAnnotation>>,
    TError,
    { pizzaId: string; data: BodyType<PutUpdateAnnotationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putUpdateAnnotation>>,
  TError,
  { pizzaId: string; data: BodyType<PutUpdateAnnotationBody> },
  TContext
> => {
  const mutationKey = ["putUpdateAnnotation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putUpdateAnnotation>>,
    { pizzaId: string; data: BodyType<PutUpdateAnnotationBody> }
  > = (props) => {
    const { pizzaId, data } = props ?? {};

    return putUpdateAnnotation(pizzaId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutUpdateAnnotationMutationResult = NonNullable<
  Awaited<ReturnType<typeof putUpdateAnnotation>>
>;
export type PutUpdateAnnotationMutationBody = BodyType<PutUpdateAnnotationBody>;
export type PutUpdateAnnotationMutationError = ErrorType<unknown>;

export const usePutUpdateAnnotation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putUpdateAnnotation>>,
      TError,
      { pizzaId: string; data: BodyType<PutUpdateAnnotationBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putUpdateAnnotation>>,
  TError,
  { pizzaId: string; data: BodyType<PutUpdateAnnotationBody> },
  TContext
> => {
  const mutationOptions = getPutUpdateAnnotationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
